module.exports = __webpack_public_path__ + "img/ico_4.79a649f6.png";